import axios from "axios";

export const signUp = async (form_data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/signUp`,
      {
        username: form_data.username,
        name: form_data.name,
        email: form_data.email,
        password: form_data.password,
      },
    );
    return response;
  } catch (error) {
    console.log("error:", error);
    return error.response;
  }
};

export const logIn = async (form_data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/logIn`,
      {
        username_email: form_data.username_email,
        password: form_data.password,
      },
    );
    console.log("response:", response);
    return response;
  } catch (error) {
    console.log("error:", error);
    return error.response;
  }
};
